import React from 'react';
import cn from 'classnames';

import './NextPreviousSelector.styl';

interface NextPreviousSelectorProps {
  className: string;
  isNextDisabled: boolean;
  isPrevDisabled?: boolean;
  onPrevious: () => any;
  onNext: () => any;
}

export class NextPreviousSelector extends React.PureComponent<NextPreviousSelectorProps> {
  render() {
    const {isNextDisabled, onNext, isPrevDisabled, className, onPrevious} = this.props;
    const nextClass = cn('next', {disabled: isNextDisabled});
    const prevClass = cn('prev', {disabled: isPrevDisabled});
    return (
      <div className={cn('next-previous-selector', className)}>
        <button className={prevClass} onClick={isPrevDisabled ? undefined : onPrevious}>
          Prev
        </button>
        <button className={nextClass} onClick={isNextDisabled ? undefined : onNext}>
          Next
        </button>
      </div>
    );
  }
}
